import React, { useEffect, useReducer } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'

import { get } from '../../config/fetch'
import { TOKEN_GET_REPORTS } from '../../constants/constants'

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    table: {
        width: '98%',
        margin: '1em auto',
    },
}))

function Reports(props) {
    const classes = useStyles()
    const history = useHistory()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        reports: [],
    })

    useEffect(() => {
        fetchReports()
            .then(reports => {
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    reports,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }, [])

    const fetchReports = async () => {
        try {
            const { data: reports } = await get(
                `/reports?code=${TOKEN_GET_REPORTS}`,
            )

            return reports
        } catch (e) {
            throw new Error(e)
        }
    }

    const handleClick = report => {
        history.push(`/reports/${report.id}`)
    }

    const getInfoFromUrl = url => {
        const newUrl = new URL(`http://${url}`)

        const startDate = new Date(newUrl.searchParams.get('startDate'))
        const endDate = new Date(newUrl.searchParams.get('endDate'))
        const networkType = newUrl.searchParams.get('networkType')
        const lng = newUrl.searchParams.get('lng')
        const lat = newUrl.searchParams.get('lat')
        const range = Number(newUrl.searchParams.get('range')) / 1000

        return { startDate, endDate, networkType, range, lng, lat }
    }

    return (
        <div>
            <Backdrop className={classes.backdrop} open={state.loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <GridList
                cellHeight={300}
                className={classes.gridList}
                cols={4}
                spacing={16}
                style={{ padding: '1em' }}
            >
                {state.reports.map(report => (
                    <GridListTile key={report.id} cols={2}>
                        <img
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleClick(report)}
                            alt={report.name}
                            src={`https://api.mapbox.com/styles/v1/mapbox/dark-v9/static/${
                                getInfoFromUrl(report.url).lng
                            },${
                                getInfoFromUrl(report.url).lat
                            },${12},0.00,0.00/1000x600@2x?access_token=pk.eyJ1IjoiZmFyb21hcGJveCIsImEiOiJjamt6amF4c3MwdXJ3M3JxdDRpYm9ha2pzIn0.V8cqmZH6dFIcxtKoaWcZZw`}
                        />
                        <GridListTileBar
                            onClick={() => handleClick(report)}
                            cols={1}
                            title={report.description}
                            subtitle={<span>Network type: {report.networkType || 'N/A'}</span>}
                            style={{ cursor: 'pointer' }}
                        />
                        <GridListTileBar
                            onClick={() => handleClick(report)}
                            className={classes.titleBar}
                            titlePosition="top"
                            cols={1}
                            title={report.name}
                            style={{ cursor: 'pointer' }}
                        />
                    </GridListTile>
                ))}
            </GridList>
        </div>
    )
}

export default Reports
